export const transactions = (state) => state.treasuryAccounts;
export const dataToRelateToTreasuryAccount = (state) => state.dataToRelateToTreasuryAccount;
